import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AiCourseCategory } from '../ai-generator.models';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';

export class ExtraInformationInput {
  name: any;
  value: any;
  placeholder?: string;
  label: string = '';
  type: 'text' | 'textarea' | 'select' = 'text';
  options: string[] = []

  constructor(inputInfo: {name: any, value: any, placeholder?: string, label: string, type?: 'text' | 'textarea' | 'select', options?: string[]}) {
    Object.assign(this, { ...inputInfo });
    if (!this.placeholder?.length) {
      switch (this.type) {
        case 'select':
          this.placeholder = `Any`;
          break;
      
        default:
          this.placeholder = `Enter Your ${this.label}`;
          break;
      }
      
    }
  }
}
@Component({
  selector: 'app-ai-extra-information-input',
  templateUrl: './ai-extra-information-input.component.html',
  styleUrls: ['./ai-extra-information-input.component.css']
})
export class AiExtraInformationInputComponent implements OnInit {
  _extraInformationForm: FormGroup;
  inputs: ExtraInformationInput[] = []
  @Input('inputs') set setFormInputs (inputs: ExtraInformationInput[]) {
    const formGroup = {};
    inputs.forEach(input => {
      formGroup[input.name] = new FormControl(input.value || '');
    });
    this._extraInformationForm = new FormGroup(formGroup);
    this.inputs = inputs;
  }
  

  @Output() additionalContextChange: EventEmitter<string> = new EventEmitter<string>();


  
  // @Output() chooseOther: EventEmitter<void> = new EventEmitter<void>();
  // @Output() disableOther: EventEmitter<void> = new EventEmitter<void>();

  otherCategory: {
    status: boolean;
    value: string;
  } = {
    status: false,
    value: '',
  };
  


  constructor(private toastr: ToastrService) {}
  ngOnInit(): void {
    // this._extraInformationForm.valueChanges.subscribe((value) => {
    //   this.onUpdateValue()
    // })
  }

 
  onUpdateValue() {
    const hasValue = this.inputs.some((input) => !!input?.value?.length);
    if (!!hasValue) {

        const valMap = this.inputs.map((input) => !!input?.value?.length ? `${input.label}\n${input.value}` : '').join('\n ')
        const additionalContext = !!valMap?.length ? `here's the concept ${valMap}` : '';
        this.additionalContextChange.emit(additionalContext);
    }
  }



  // disableOther() {
  //   this.otherCategory.status = false;
  //   this.otherCategory.value = '';
  //   this.restoreSelectedCategories();
  // }

 
}
